import { ReactElement } from "react";
import { Container, Paper, Box } from '@mui/material';

// common
import { ActionCB } from "@common/type_defs";

// components
import { BannerSection } from "./components/Banner_DataHub";
import { DhxIntraSection } from "./components/Section_DhxIntra";
import { IssueSection } from "./components/Section_Issues";
import { SolutionSection } from "./components/Section_Solution";
import { FeatureSection } from "./components/Section_Feature";


const SvcDataHubPage = (): ReactElement => {
  const handleAction: ActionCB = (act, vd) => {
    if (act === "cancel") {
    } else {
    }
  };

  return (
    <>
      <BannerSection />
      <DhxIntraSection />
      <IssueSection />
      <SolutionSection />
      <FeatureSection />
      <Box sx={{ mt: 3 }}></Box>
    </>
  );
};

export default SvcDataHubPage;
